import { render } from "./search-icon.vue?vue&type=template&id=6e2b37d0"
import script from "./search-icon.vue?vue&type=script&lang=js"
export * from "./search-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__